export function focusAndOpenKeyboard(id) {
    const fakeInput = document.createElement('input');
    fakeInput.setAttribute('type', 'text');
    fakeInput.setAttribute('inputmode', 'decimal');
    fakeInput.setAttribute('pattern', '[0-9]*');
    fakeInput.setAttribute('min', '0');
    fakeInput.style.position = 'absolute';
    fakeInput.style.opacity = 0;
    fakeInput.style.transform = 'scale(0)';
    fakeInput.style.bottom = '240px';
    fakeInput.style.left = '50%';
    fakeInput.style.color = 'transparent !important';
    fakeInput.style['margin-left'] = '-93px';
    fakeInput.style.fontSize = '2rem'; // disable auto zoom

    // you may need to append to another element depending on the browser's auto
    // zoom/scroll behavior
    document.getElementById(id).prepend(fakeInput);

    // focus so that subsequent async focus will work
    fakeInput.focus();
    fakeInput.select();

    setTimeout(() => {
        // now we can focus on the target input
        document.getElementById(id).focus();
        document.getElementById(id).select();

        // cleanup
        fakeInput.remove();
    }, 500);
}
